<template>
	<div
		:class="$style['skeleton-row']"
		:style="styles"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'SkeletonRow',
	props: {
		gutter: {
			type: String,
			default: '10px'
		},
		marginBottom: {
			type: String,
			default: '0px'
		},
		custom: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		styles () {
			const styles = {}
			styles.marginLeft = `-${this.gutter}`
			styles.marginRight = `-${this.gutter}`
			styles.marginBottom = this.marginBottom
			return { ...styles, ...this.custom }
		}
	}
}
</script>

<style lang="scss" module>
.skeleton-row {
		display: flex;
	}
</style>
